import type { CSSProperties, Ref } from 'react';
import type { CampaignCountdownProps, CampaignCountdownUnit } from './const';
import { cn } from '@utils';
import { forwardRef, Fragment } from 'react';
import './index.less';

function Separator() {
  return (
    <div className="wg-campaign-countdown__separator" aria-hidden="true">
      <div className="wg-campaign-countdown__dot" />
      <div className="wg-campaign-countdown__dot" />
    </div>
  );
}

function CountdownUnit({ label, value }: CampaignCountdownUnit) {
  return (
    <div className="wg-campaign-countdown__unit">
      <div className="wg-campaign-countdown__value-box">
        <span className="wg-campaign-countdown__value">{value}</span>
      </div>
      <span className="wg-campaign-countdown__label">{label}</span>
    </div>
  );
}

function getCountdownStyle(
  style: CSSProperties | undefined,
  labelColor: string | undefined,
  separatorColor: string | undefined,
) {
  return {
    ...style,
    ...(labelColor ? { '--wg-campaign-countdown-label-color': labelColor } : {}),
    ...(separatorColor ? { '--wg-campaign-countdown-separator-color': separatorColor } : {}),
  } as CSSProperties;
}

function CampaignCountdown(props: CampaignCountdownProps, ref: Ref<HTMLDivElement>) {
  const {
    units,
    size = 'default',
    labelColor,
    separatorColor,
    className,
    style,
    ...rest
  } = props;

  return (
    <div
      {...rest}
      ref={ref}
      className={cn('wg-campaign-countdown', `wg-campaign-countdown--${size}`, className)}
      style={getCountdownStyle(style, labelColor, separatorColor)}
    >
      {units.map((unit, index) => (
        <Fragment key={`${unit.label}-${index}`}>
          {index > 0 && <Separator />}
          <CountdownUnit {...unit} />
        </Fragment>
      ))}
    </div>
  );
}

const CampaignCountdownComponent = forwardRef<HTMLDivElement, CampaignCountdownProps>(CampaignCountdown);

CampaignCountdownComponent.displayName = 'CampaignCountdown';

export default CampaignCountdownComponent;
export type { CampaignCountdownProps, CampaignCountdownUnit } from './const';
